// extracted by mini-css-extract-plugin
export var card = "styles-module--card--1bQ+b";
export var image = "styles-module--image--umx+j";
export var heading = "styles-module--heading--HE5gI";
export var description = "styles-module--description--a+6fz";
export var content = "styles-module--content--Kz+BV";
export var ctaLink = "styles-module--ctaLink--Ntw7S";